module.exports = __webpack_public_path__ + "img/CS4-4.b3d965a0.png";